"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEditableTableForm = exports.EditableTableFormProvider = exports.EditableContext = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _util = require("./../util");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var EditableContext = exports.EditableContext = /*#__PURE__*/_react.default.createContext(null);
var useEditableTableForm = exports.useEditableTableForm = function useEditableTableForm() {
  return _react.default.useContext(EditableContext);
};
var EditableTableFormProvider = exports.EditableTableFormProvider = function EditableTableFormProvider(_ref) {
  var children = _ref.children,
    editingRowKey = _ref.editingRowKey,
    onFormValuesChange = _ref.onFormValuesChange,
    rowKey = _ref.rowKey;
  var form = _react.default.useRef(null);
  var focusedInputRef = _react.default.useRef(null);
  var keyRef = _react.default.useRef('');
  var dataIndexRef = _react.default.useRef(null);
  var _React$useState = _react.default.useState(''),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    editingKey = _React$useState2[0],
    _setEditingKey = _React$useState2[1];
  var _React$useState3 = _react.default.useState(null),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    selectedDataIndex = _React$useState4[0],
    _setSelectedDataIndex = _React$useState4[1];
  function isRowEditing(record) {
    var key = (0, _util.getRecordKeyByRowKey)(rowKey, record, selectedDataIndex);
    return record && key === editingKey;
  }
  function isCellEditing(record, dataIndex) {
    var key = (0, _util.getRecordKeyByRowKey)(rowKey, record, dataIndex);
    return record && key && key === editingKey && dataIndex === selectedDataIndex;
  }
  (0, _react.useEffect)(function () {
    keyRef.current = editingRowKey;
    _setEditingKey(editingRowKey);
  }, [editingRowKey]);
  return /*#__PURE__*/_react.default.createElement(EditableContext.Provider, {
    value: {
      form: form,
      focusedInputRef: focusedInputRef,
      editingKey: editingKey,
      setEditingKey: function setEditingKey(value) {
        keyRef.current = value;
        _setEditingKey(value);
      },
      selectedDataIndex: selectedDataIndex,
      setSelectedDataIndex: function setSelectedDataIndex(value) {
        dataIndexRef.current = value;
        _setSelectedDataIndex(value);
      },
      isRowEditing: isRowEditing,
      isCellEditing: isCellEditing,
      keyRef: keyRef,
      rowKey: rowKey,
      dataIndexRef: dataIndexRef,
      onFormValuesChange: onFormValuesChange
    }
  }, children);
};